export const routeDistanceOptions = [
    { label: '1 mile', value: 1 },
    { label: '2 miles', value: 2 },
    { label: '3 miles', value: 3 },
    { label: '4 miles', value: 4 },
    { label: '5 miles', value: 5 },
    { label: '6 miles', value: 6 },
    { label: '7 miles', value: 7 },
    { label: '8 miles', value: 8 },
    { label: '9 miles', value: 9 },
    { label: '10 miles', value: 10 },
    { label: '15 miles', value: 15 },
    { label: '20 miles', value: 20 },
    { label: '25 miles', value: 25 },
    { label: '30 miles', value: 30 },
    { label: '40 miles', value: 40 },
    { label: '50 miles', value: 50 },
]
